import React from 'react';
import OtherImage from '../../components/ImagesComponent/OtherImage';
import picError from '../../assets/images/pic-error-blue.svg';
import { useSelector } from 'react-redux';
import { selectorsLocale } from '../../redux/locale/localeReducer';
import { buildLocale } from '../../utils/buildLocale';

const SystemErrorPage: React.FC = () => {
  const currentTranslate = useSelector(selectorsLocale.getTranslate);

  return (
    <section className="section-404">
      <figure className="section-404_pic">
        <OtherImage src={picError} title="" width="408" height="244" />
      </figure>
      <div className="section-404_text">
        <p> {buildLocale(currentTranslate, 'errorSite')}</p>
        <p> {buildLocale(currentTranslate, 'errorProblemsSite')}</p>
      </div>
    </section>
  );
};

export default SystemErrorPage;
